import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../Button/index';
import './ManagementWay.css';

const ManagementWay = ({ handleSaveManagementWay, handleNextStep }) => (
  <div className="management-way-card">
    <div className="management-way-card__managed">
      <div className="management-way-card--title">Managed Service</div>
      <div className="management-way-card--image-managed" />
      <div className="management-way-card--content">
        <p>
          <i>
            Is best if you require more creative help. We&apos;ll manage the
            project every step of the way so you can rest easy.
          </i>
        </p>
        <h4>Best if you need help with:</h4>
        <p>Creative Concepting</p>
        <p>Scripting</p>
        <p>Storyboarding</p>
        <p>Selecting Appropriate Platforms</p>
        <p>Platform Optimization</p>
        <p>Complex Projects</p>
      </div>
      <div className="management-way-card--actions">
        <Button
          className="management-way-card--actions--managed"
          rounded
          title="Managed"
          onClick={event => handleSaveManagementWay(event, 'managed')}
        />
      </div>
    </div>
    <div className="management-way-card__marketplace">
      <div className="management-way-card--title">Marketplace</div>
      <div className="management-way-card--image-marketplace" />
      <div className="management-way-card--content">
        <p>
          <i>
            Allows you to directly manage your project: you pick your creator,
            you provide all the required information, and you get the video you
            want!
          </i>
        </p>

        <h4>Best if you’ve got these covered:</h4>
        <p>My vision for this vido is clear enough for a vieo pro to start.</p>
        <p>
          I’ll provide most of the assets such as script music, and voiceover
          for a video pro to work with.
        </p>
      </div>
      <div className="management-way-card--actions">
        <Button
          className="management-way-card--actions--marketplace"
          rounded
          title="Marketplace"
          onClick={handleNextStep}
        />
      </div>
    </div>
  </div>
);

ManagementWay.propTypes = {
  handleSaveManagementWay: PropTypes.func,
  handleNextStep: PropTypes.func,
};

export default ManagementWay;



// WEBPACK FOOTER //
// ./src/components/ProjectManagement/ManagementWay/ManagementWay.js